module.exports = __webpack_public_path__ + "static/media/image3.5241f267.png";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/carAuthorization/img/image3.png
// module id = 327
// module chunks = 0